import { Box, Icon, type IColumn, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type ReviewContactRow } from 'entities/Review'
import { getCellForTags } from 'widgets/ContactEnrollment/ui/EnrollmentContactsTable'
import { ReviewContactNameCell } from 'pages/reviews/pages/viewReview/ui/ReviewContactsTable/ReviewContactNameCell'

export const columns: IColumn<ReviewContactRow>[] = [
  {
    field: 'full_name',
    name: 'Name',
    isDisabledChangeVisible: true,
    isSortable: true,
    width: '100%',
    minWidth: 266,
    maxWidth: 266,
    renderRowCell: (row, _, config) => <ReviewContactNameCell row={row} config={config} />,
  },
  {
    field: 'number',
    name: 'Number',
    width: '129px',
    minWidth: '129px',
    renderRowCell: ({ formattedNumber }) =>
      formattedNumber ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactNumber'}>
          {getLabelAsNumberInternationalFormat(formattedNumber)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'rating',
    name: 'Stars',
    width: '80px',
    renderRowCell: ({ rate }) => (
      <Box display={'flex'} alignItems={'center'} gap={'4px'}>
        <Icon icon={'starFilled1'} fontSize={14} color={'var(--yellow-70)'} />
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactStars'}>
          {rate}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'feedback',
    name: 'Feedback',
    width: '39%',
    minWidth: 290,
    maxWidth: 435,
    renderRowCell: ({ comment }) =>
      comment ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactFeedback'} ellipsis>
          {comment}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'submitted_at',
    name: 'Submitted at',
    width: '170px',
    minWidth: '170px',
    renderRowCell: ({ createdAt }) =>
      createdAt ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactSubmittedAt'}>
          {uiStore.dayjs(createdAt).format(DayjsFormats.fullWithAtDash)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'tags',
    name: 'Tags',
    renderRowCell: (row) => getCellForTags({ tags: row.tags, isDisabled: row.isDisabled }),
  },
]
